import React from 'react';
import {Button, Form, Icon, Input, Label, Message} from 'semantic-ui-react';
import {Controller, useForm} from 'react-hook-form';
import {useAppDispatch} from "../../../../hooks/hooks";
import {invitePlayer} from "../DartsPlayersCRUD.slice";

interface InviteFormData {
    email: string;
}

interface InviteFormProps {
    closeForm: () => void
}

const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const emailMessage = "Enter valid player's email.";

const InviteForm:React.FC<InviteFormProps> = ({closeForm}) => {
    const dispatch = useAppDispatch()
    const {
        control,
        handleSubmit,
        formState: {errors},
        reset,
    } = useForm<InviteFormData>();

    const onSubmit = (data: InviteFormData) => {
        dispatch(invitePlayer({email: data.email}))
        reset();
        closeForm()
    };

    return (
        <div className="form-overlay-general">
            <Form className="players-form" onSubmit={handleSubmit(onSubmit)}>
                <Icon color="red" name="close" size="large" style={{float: 'right', cursor: 'pointer'}}
                    onClick={() => closeForm()} />
                <div className="form-header" style={{ textAlign: 'center', margin: '20px 0', fontWeight: 'bold' }}>
                    <p className="form-title">An invitation to join your group will be sent to the email address below.</p>
                    <p className="form-title">Ask the recipient to check their email.</p>
                </div>
                <div className="form-row">
                    <Form.Field error={!!errors.email} style={{ width: '100%' }}>
                        <Label className="players-form-label">Email</Label>
                        <Controller as={Input} name="email" control={control} defaultValue="" placeholder={emailMessage}
                            rules={{ required: "Email is required", pattern: { value: emailRegex, message: emailMessage }}}
                        />
                        {errors.email && 
                            <Message negative size="tiny">
                                {errors.email.message}
                            </Message>
                        }
                    </Form.Field>
                </div>

                <div className="submit-btn">
                    <Button type="submit" id="save_player" color="green">
                        Invite
                    </Button>
                </div>
            </Form>
        </div>
    );
};

export default InviteForm;
